import fetch from "../../uilts/request.js";

export default {
  save(data) {
    return fetch.post('/PhoneZulin/save', data)
  },
  // 获取用户信息
  getMember(data) {
    return fetch.post('/PhoneZulin/getMember', data)
  },
   submitPhoneZulin(data) {
    return fetch.post('/Contract/createZuLin', data)
  },

}